import { LoginResponse, LoginReturn, ResetPasswordResponse } from '~services/authentication/types';

export const isResetPasswordResponse = (response: LoginResponse | LoginReturn): response is ResetPasswordResponse => {
    return (response as ResetPasswordResponse).resetPasswordToken !== undefined;
};
